/**
 * The size of a Cloudflare Turnstile widget for the element it renders into.
 * The „normal” widget is 300 pixels wide, so a narrower form column (a 320-pixel
 * phone) takes the 150-pixel „compact” one instead of pushing the page
 * sideways; wider columns keep the default. A mount that is not laid out yet
 * (width 0: a hidden panel of the map's signal wizard) is judged by the screen,
 * where a column of a phone narrower than TURNSTILE_NARROW_VIEWPORT is narrower
 * than the widget.
 *
 * Twins in the hand-written scripts that cannot import it:
 * assets/public/js/portal-pages.js and assets/public/js/property-listings.js.
 */
export const TURNSTILE_NORMAL_WIDTH = 300;
export const TURNSTILE_NARROW_VIEWPORT = 360;

export function turnstileSize(mount) {
    const width = mount && typeof mount.getBoundingClientRect === 'function'
        ? mount.getBoundingClientRect().width
        : 0;
    if (width > 0) return width < TURNSTILE_NORMAL_WIDTH ? 'compact' : 'normal';
    const viewport = typeof document !== 'undefined' && document.documentElement ? document.documentElement.clientWidth : 0;
    return viewport > 0 && viewport < TURNSTILE_NARROW_VIEWPORT ? 'compact' : 'normal';
}
